import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import React, { useCallback } from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    modalheader: {
        color: theme.palette.primary.main,
    },
    closeButton: {
        position: 'absolute',

        right: theme.spacing(2),
        color: theme.palette.common.black,
    },
}))
export interface MoreInfoDialogModalProps {
    open: boolean
    onClose: () => void
}

const MoreInfoDialogModal: React.FC<MoreInfoDialogModalProps> = ({
    open,
    onClose,
}) => {
    const classes = useStyles()

    const handleClose = useCallback(
        (_, reason) => {
            if (reason === 'escapeKeyDown') {
                onClose()
            }
        },
        [onClose]
    )
    return (
        <Dialog open={open} maxWidth="sm" onClose={handleClose}>
            <DialogTitle>
                <Typography
                    variant="h1"
                    component="span"
                    className={classes.modalheader}
                >
                    Understanding Product Listings in Specpoint
                </Typography>
                <IconButton
                    className={classes.closeButton}
                    data-testid="close-btn"
                    aria-label="close"
                    size="small"
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent tabIndex={0}>
                <Typography>
                    Specpoint provides a database of Product Cards as a resource
                    to help with product selections for construction projects.
                    <br />
                    <br />
                    This guide describes the two types of Product Cards
                    available in Specpoint.
                    <br />
                    <br />
                    <b>MasterSpec Verified Product Cards</b>
                    <br />
                    <br />
                    This type of Product Card indicates that the product has
                    undergone a rigorous verification and evaluation process by
                    Deltek's MasterSpec professional writing team, made up of
                    experienced certified specifiers and/or licensed architects
                    and engineers. This means:  <br />
                    <br />
                    <ul>
                        <li>
                            Expert Review: These products have been evaluated to
                            verify that they comply with key specific
                            requirements of the relevant MasterSpec section and
                            Product Type.
                        </li>
                        <li>
                            Verification: The verification process is based on
                            review of the published information provided by the
                            product's manufacturer, including what is available
                            on the manufacturer's website, at the time of
                            listing. This additional layer of review provides a
                            higher level of confidence in the product’s
                            compliance with MasterSpec requirements.
                        </li>
                    </ul>
                    The products that have been MasterSpec verified are intended
                    to provide a helpful filter to only list products that
                    satisfy the descriptive, reference standard, and performance
                    requirements of the Product Types included within the
                    specification section.
                    <br />
                    <br />
                    <b>General Distribution Product Cards</b>
                    <br />
                    <br />
                    This type of Product Card has been reviewed only for
                    placement within the appropriate section. No further
                    evaluation has been conducted. This means:
                    <br />
                    <br />
                    <ul>
                        <li>
                            Basic Review: These products have been evaluated
                            only for their likeliest appropriate placement  in
                            the AIA MasterSpec and CSI MasterFormat framework.
                        </li>
                        <li>
                            No Additional Verification: There has been no
                            further evaluation to determine whether these
                            products comply with specific standards or fire and
                            life safety requirements.
                        </li>
                    </ul>
                    This type of listing serves as an open resource, offering a
                    broad array of products that can be considered for various
                    projects. It is crucial that the Design Professional does
                    their due diligence and conducts a thorough review to
                    confirm the product's suitability for the specific needs of
                    each Project and to confirm compliance with specific
                    standards, fire and life safety requirements.  <br />
                    <br />
                    <b>Important Considerations for All Product Cards</b>
                    <br />
                    <br />
                    Regardless of the listing type, it is still essential for
                    the Design Professional to verify the following criteria
                    before adding products to their project: 
                    <br />
                    <br />
                    <ul>
                        <li>
                            Availability: Ensure that the product is available
                            in your region and within your project timeline.
                        </li>
                        <li>
                            Suitability: Confirm that the product is appropriate
                            for the specific requirements and conditions of your
                            project.
                        </li>
                        <li>
                            Compliance: Check that the product complies with the
                            minimum performance requirements and standards
                            necessary for your project.
                        </li>
                    </ul>
                </Typography>
            </DialogContent>
        </Dialog>
    )
}
export default MoreInfoDialogModal
